<template>
    <div class="view">
        <h2>Bilan trimestriel des recrutements</h2>
        <b-form @submit="onSubmit" v-if="show" @keypress.enter.prevent>

            <b-col cols="10">

                <b-row align-h="between">
                    <b-col cols="4">
                        <b-form-group id="input-group-marches" label-for="input-marches" v-if="isAdmin">
                            <template v-slot:label>
                                <label-custom
                                        label="Marché"
                                        :tooltip=libelles.infoBulleNumMarche
                                        :required="true">
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                id="input-marches"
                                :items="marcheIdsItems"
                                v-model="marcheAdmin"
                                @search="onMarcheSearch"
                                :required="true"
                                :disabled="mode === 'UPDATE' || mode === 'READ'"
                                :placeholder=libelles.selectionnerMarche
                                >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <div class="user-info">
                            <p style="margin-bottom: 10px; text-align: center;">
                                <strong>Créateur de la saisie</strong>
                            </p>
                            <template v-if="user.nom.trim() || user.prenom.trim() || user.email.trim()">
                                <p><strong>Nom :</strong> {{ user.nom }}</p>
                                <p><strong>Prénom :</strong> {{ user.prenom }}</p>
                                <p><strong>Email :</strong> {{ user.email }}</p>
                            </template>
                            <template v-else>
                                <p class="no-data">La donnée n’est pas disponible</p>
                            </template>
                        </div>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-trimestres" label-for="input-trimestres">
                            <template v-slot:label>
                                <label-custom
                                        label="Trimestre de la saisie"
                                        tooltip="Trimestre au cours duquel la saisie est réalisée, à ne pas confondre avec les trimestres pour lesquels la saisie est réalisée, et qui apparaissent plus bas"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-trimestres"
                                    v-model="trimestre"
                                    :options="trimestres"
                                    :disabled="mode === 'UPDATE' || mode === 'READ'"
                                    @change="callInit"
                                    :state="getFieldState(trimestre != null)">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un trimestre
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    
                </b-row>

                <b-row>
                    <b-col cols="8" v-if="marcheId && trimestre && mode === 'CREATE'">
                        <label-custom :label= libelles.libelleRienDeclarer></label-custom>
                        <b-button type="button" variant="primary" v-b-modal="'modal-dispense'">{{libelles.buttonRienDeclarer}}
                        </b-button>
                        <b-modal
                                :id="'modal-dispense'"
                                :title= libelles.demandeConfirmation
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="saveDispense()">
                            <p>{{libelles.confirmationDispenseUtilisateur}}</p>
                        </b-modal>
                    </b-col>
                </b-row>

                <div v-if="marcheId && trimestre">

                    <b-card header="Filtres de recherche" class="mb-3 mt-3">
                        <b-row>
                            <b-col>
                                <b-form-group
                                        label="Filtrer par libellé de poste"
                                        id="input-group-filterLibellePoste"
                                        label-for="input-filterLibellePoste">
                                    <b-form-input
                                            id="input-group-filterLibellePoste"
                                            v-model="filterLibellePoste"
                                            type="text"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        label="Filtrer par statut de validation"
                                        id="input-group-filterStatutPoste"
                                        label-for="input-filterStatutPoste">
                                    <b-form-select
                                            id=""
                                            v-model="filterStatutPoste">
                                        <b-form-select-option :value="null">
                                            Tous
                                        </b-form-select-option>
                                        <b-form-select-option :value="'valid'">
                                            Validés et incomplets
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>

                    <b-tabs content-class="mt-3" fill v-if="synthese">
                        <b-tab>
                            <template #title>
                                <div v-b-tooltip.hover
                                     :title="'Le trimestre saisi ci-dessous correspond au trimestre T-1'">
                                    {{formatTrimestre(synthese.trimestrePrecedent ? synthese.trimestrePrecedent.libelle : '')}}
                                </div>
                            </template>
                            <b-row align-h="end" class="mb-3">
                                <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
                            </b-row>
                            <div class="accordion" role="tablist">
                                <div v-for="(poste, posteIndex) in currentPostes"
                                     :key="posteIndex">
                                    <div v-if="(posteIndex === 0 || (poste.codeRome.type !== currentPostes[posteIndex - 1].codeRome.type))">
                                        <b-card class="text-center" v-if="poste.codeRome.type != null">
                                            {{typologiePosteEnum[poste.codeRome.type]}}
                                        </b-card>
                                        <b-card class="text-center" v-if="poste.codeRome.type == null">
                                            Type non renseigné
                                        </b-card>
                                    </div>
                                    <b-card no-body class="mb-1">
                                        <b-card-header header-tag="header" class="p-1 mb-0" role="tab">
                                            <b-row>
                                                <b-col cols="11">
                                                    <b-button block
                                                              v-b-toggle="'poste_' + posteIndex"
                                                              :variant="getStatus(poste)">
                                                        {{poste.codeRome.libelle}} ({{poste.codeRome.code}})
                                                    </b-button>
                                                </b-col>
                                                <b-col cols="1">
                                                    <b-button v-b-modal="'modal-delete_' + posteIndex"
                                                              variant="danger"
                                                              v-b-tooltip.hover
                                                              :title="'Supprimer le poste de la liste'"
                                                              :disabled="mode === 'READ'">
                                                        <Icon icon="trash" size="1x"></Icon>
                                                    </b-button>
                                                    <b-modal
                                                            :id="'modal-delete_' + posteIndex"
                                                            :title="poste.codeRome.libelle"
                                                            ok-title="Confirmer"
                                                            cancel-title="Annuler"
                                                            @ok="deletePoste(posteIndex)">
                                                        <p>Souhaitez-vous supprimer ce poste de la liste du référentiel
                                                            ?</p>
                                                        <p>Si vous poursuivez, le poste n’apparaîtra plus pour ce
                                                            trimestre,
                                                            mais pourra être de nouveau ajouté manuellement en cliquant
                                                            sur ‘Ajouter un nouveau poste’.
                                                        </p>
                                                    </b-modal>
                                                </b-col>
                                            </b-row>
                                        </b-card-header>
                                        <b-collapse :id="'poste_' + posteIndex"
                                                    :accordion="'my-accordion'" role="tabpanel">
                                            <b-card-body>
                                                <b-row>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-typePoste_' + posteIndex"
                                                                :label-for="'input-typePoste_' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Typologie de poste"
                                                                        :required="true">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-select
                                                                    :id="'input-typePoste_' + posteIndex"
                                                                    v-model="poste.codeRome.type"
                                                                    :options="typologies"
                                                                    @change="poste.isTouched = true"
                                                                    :disabled="true"
                                                                    :state="getFieldState(poste.codeRome.type != null, poste)">
                                                            </b-form-select>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-nbRecrutement_' + posteIndex"
                                                                :label-for="'input-nbRecrutement_' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Nombre d'effectifs"
                                                                        tooltip="Indiquer le nombre d’effectifs recrutés en équivalent temps plein"
                                                                        :required="true">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-input
                                                                    :id="'input-nbRecrutement_' + posteIndex"
                                                                    v-model="poste.nbRecrutement"
                                                                    type="number"
                                                                    min="0"
                                                                    step="any"
                                                                    v-on:input="poste.isTouched = true"
                                                                    :state="getFieldState(isFilledInput(poste.nbRecrutement), poste)"
                                                                    :disabled="mode === 'READ'"></b-form-input>
                                                            <div class="typo-warning"
                                                                 v-if="!areDureesContratValid(poste)">
                                                                Le nombre d'effectif ne correspond pas aux durées de
                                                                contrat
                                                                renseignées
                                                            </div>
                                                            <div class="typo-warning"
                                                                 v-if="!areTypesContratValid(poste)">Le
                                                                nombre d'effectifs total renseignés et les effectifs
                                                                associés à chaque type de contrat ne correspondent pas
                                                            </div>
                                                            <div class="typo-warning"
                                                                 v-if="!areTypesFormationValid(poste)">Le total des
                                                                effectifs en
                                                                formation saisi est supérieur au total des effectifs
                                                                à recruter sur ce poste. Merci de modifier votre saisie
                                                                afin de la rendre valide
                                                            </div>
                                                            <div class="typo-warning"
                                                                 v-if="!areEntreeSortieEntrepriseValid(poste)">Le nombre
                                                                d'effectif doit être supérieur ou égal aux perspectives
                                                                professionnelles des personnes en insertion à l'issue du
                                                                contrat
                                                            </div>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-integrationEntreprise' + posteIndex"
                                                                :label-for="'input-integrationEntreprise' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Intégration au sein de l'entreprise"
                                                                        tooltip="Indiquer le nombre d’effectifs en équivalent temps plein qui ont été recrutées sur ce poste sur le trimestre écoulé">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-input
                                                                    :id="'input-integrationEntreprise_' + posteIndex"
                                                                    v-model="poste.integrationEntreprise"
                                                                    type="number"
                                                                    min="0"
                                                                    step="any"
                                                                    v-on:input="poste.isTouched = true"
                                                                    :state="getFieldState(true, poste)"
                                                                    :disabled="mode === 'READ'"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-sortieEntreprise' + posteIndex"
                                                                :label-for="'input-sortieEntreprise' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Sortie de l'entreprise"
                                                                        tooltip=" Indiquer le nombre d’effectifs en équivalent temps plein qui occupaient ce poste et ont quitté l’entreprise durant le trimestre écoulé">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-input
                                                                    :id="'input-sortieEntreprise_' + posteIndex"
                                                                    v-model="poste.sortieEntreprise"
                                                                    type="number"
                                                                    min="0"
                                                                    step="any"
                                                                    v-on:input="poste.isTouched = true"
                                                                    :state="getFieldState(true, poste)"
                                                                    :disabled="mode === 'READ'"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-card no-body class="mb-2">
                                                    <b-card-header>
                                                        <div class="typo-required-field">Durée du contrat</div>
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <duree-contrat-gpec v-model="poste.dureesContrat"
                                                                            :dureesContratEnum="dureesContratEnum"
                                                                            :formSubmitted="formSubmitted"
                                                                            :posteTouched="poste.isTouched"
                                                                            v-on:input="poste.isTouched = true"
                                                                            :disabled="mode === 'READ'"></duree-contrat-gpec>
                                                    </b-card-body>
                                                </b-card>
                                                <b-card no-body class="mb-2">
                                                    <b-card-header>
                                                        <div class="typo-required-field">Type de contrat</div>
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <type-contrat-gpec v-model="poste.typesContrat"
                                                                           :typesContratEnum="typesContratEnum"
                                                                           :formSubmitted="formSubmitted"
                                                                           :posteTouched="poste.isTouched"
                                                                           v-on:input="poste.isTouched = true"
                                                                           :disabled="mode === 'READ'"></type-contrat-gpec>
                                                    </b-card-body>
                                                </b-card>
                                                <b-card no-body>
                                                    <b-card-header header-tag="header" v-b-tooltip.hover
                                                                   :title="'Indiquer la mise en place d’une éventuelle formation dispensée en accompagnement du poste'">
                                                        Formation principale délivrée
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <formation-gpec v-model="poste.formation"
                                                                        :trimestreIndex="0"
                                                                        :posteIndex="posteIndex"
                                                                        :typesFormation="typesFormation"
                                                                        :formSubmitted="formSubmitted"
                                                                        :posteTouched="poste.isTouched"
                                                                        v-on:input="poste.isTouched = true"
                                                                        :disabled="mode === 'READ'"></formation-gpec>
                                                    </b-card-body>
                                                </b-card>
                                                <b-card
                                                        no-body
                                                        class="mt-2"
                                                        >
                                                    <b-card-header
                                                            header-tag="header"
                                                            v-b-tooltip.hover
                                                            :title=gpecRealise.infoBulleEntreprisesConcernees>
                                                        {{gpecRealise.libelleEntreprisesConcernees}}
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col>
                                                                <b-form-group
                                                                        :id="'input-group-entreprisesConcernees_' + posteIndex"
                                                                        :label-for="'input-entreprisesConcernees_' + posteIndex"
                                                                        >
                                                                    <b-form-textarea v-on:keyup.enter='addLineBreak($event,poste,"entreprisesConcernees",true)'
                                                                            :id="'input-entreprisesConcernees_' + posteIndex"
                                                                            :value="poste.entreprisesConcernees"
                                                                            rows="3"
                                                                            max-rows="4"
                                                                            :disabled="mode === 'READ'"
                                                                            v-on:change='addLineBreak($event,poste,"entreprisesConcernees")'
                                                                            >
                                                                    </b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-card>
                                                <b-row class="mt-3" v-if="mode === 'CREATE'">
                                                    <b-col class="text-center">
                                                        <b-button type="button" variant="primary"
                                                                  @click="saveDraft"
                                                                  :disabled="!isValid(poste)">
                                                            Enregistrer le poste
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                    <div v-if="currentPostes && currentPostes.length === 0">Aucun poste ne correspond à vos critères de
                        recherche
                    </div>

                    <b-row class="mt-3">
                        <b-col class="text-center">
                            <b-button type="button" variant="primary"
                                      @click="showModalAddPoste"
                                      v-if="mode === 'CREATE' || mode === 'UPDATE'">
                                Ajouter un nouveau poste
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-modal
                            id="modal-add-poste"
                            title="Ajouter un nouveau poste"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            hide-footer
                            @hidden="addPoste">
                        <CreerCodeRome
                                :codeRome="newCodeRome"
                        ></CreerCodeRome>
                    </b-modal>
                </div>

                <b-row v-if="mode !== 'CREATE'">
                    <b-col>
                        <b-form-group id="input-group-commentaire"
                                      label-for="input-commentaire">
                            <label-custom
                                    label="Commentaire"
                                    tooltip="Espace à compléter si vous souhaitez préciser le motif de la modification du formulaire"
                                    :required="synthese.jourSoumissionPassed">
                            </label-custom>
                            <b-form-textarea v-on:keyup.enter='addLineBreak($event,synthese,"commentaire",true)'
                                    id="input-commentaire"
                                    :value="synthese.commentaire"
                                    rows="3"
                                    max-rows="5"
                                    :state="getCommentaireState()"
                                    :disabled="mode === 'READ'"
                                     @change='addLineBreak($event,synthese,"commentaire")'
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6" v-if="synthese.statut === 'REFUSE'">
                        <b-form-group
                            id="input-group-commentaire-statut"
                            :label="libelles.commentaireStatut"
                            label-for="input-commentaire-statut"
                        >
                            <b-form-textarea
                                id="input-commentaire"
                                :value="synthese.commentaireStatut"
                                rows="3"
                                max-rows="5"
                                disabled
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="pt-2" v-if="mode !== 'READ'">
                    <b-button type="submit" variant="primary" @click="formSubmitted = true">Soumettre le formulaire
                    </b-button>
                </div>

                <div class="pt-2" v-if="mode === 'READ' && isAdminGpec">
                    <b-button
                            v-if="synthese.statut === 'ATTENTE_MODIFICATION' || synthese.statut === 'ATTENTE_SUPPRESSION'"
                            type="button" variant="primary" @click="validerSynthese(synthese)">
                        <span v-if="synthese.statut === 'ATTENTE_MODIFICATION'">Confirmer la modification</span>
                        <span v-if="synthese.statut === 'ATTENTE_SUPPRESSION'">Confirmer la suppression</span>
                    </b-button>
                </div>

            </b-col>

        </b-form>
        <br/>
    </div>

</template>

<script>
  import SessionStore from '@/stores/SessionStore'
  import AlertStore from '@/stores/AlertStore'
  import hasPermission from "../../../filters/hasPermission";
  import MarcheStore from "../../../stores/MarcheStore";
  import TypeFormationStore from "../../../stores/TypeFormationStore";
  import GpecSyntheseRealiseStore from "../../../stores/GpecSyntheseRealiseStore";
  import LabelCustom from "../../../components/LabelCustom";
  import CreerCodeRome from "../../code-rome/CreerCodeRome";
  import TypeContratGpec from "../../../components/gpec/TypeContratGpec";
  import DureeContratGpec from "../../../components/gpec/DureeContratGpec";
  import FormationGpec from "../../../components/gpec/FormationGpec";
  import GpecSyntheseRealiseDto from "../../../dtos/GpecSyntheseRealiseDto";
  import {DureeContratEnum, TypeContratEnum, TypologiePosteEnum} from "../../../constants/enums";
  import CodeRomeDto from "../../../dtos/CodeRomeDto";
  import PosteRealiseDto from "../../../dtos/PosteRealiseDto";
  import formatTrimestre from "../../../filters/formatTrimestre";
  import TrimestreStore from "../../../stores/TrimestreStore";
  import {gpecRealise, libelles} from '../../../constants/libelles';
  import DispenseReportingDto from "../../../dtos/DispenseReportingDto";
  import ReportingStore from "../../../stores/ReportingStore";
  import AutocompleteCustom from "../../../components/AutocompleteCustom";
  import {EventBus} from '@/event-bus'

  export default {
    components: {LabelCustom, FormationGpec, TypeContratGpec, DureeContratGpec, CreerCodeRome, AutocompleteCustom},
    data() {
      return {
        formSubmitted: false,
        show: true,
        sessionStoreState: SessionStore.state,
        filterLibellePoste: null,
        filterStatutPoste: null,
        synthese: new GpecSyntheseRealiseDto(),
        newCodeRome: null,
        marcheAdmin: null,
        marchesAdmin: [],
        marches: [],
        typologiePosteEnum: TypologiePosteEnum,
        typologies: Object.entries(TypologiePosteEnum).map(value => {
          return {text: value[1], value: value[0]}
        }),
        dureesContratEnum: Object.entries(DureeContratEnum).map(value => {
          return {text: value[1], value: value[0]}
        }),
        typesContratEnum: Object.entries(TypeContratEnum).map(value => {
          return {text: value[1], value: value[0]}
        }),
        typesFormation: [],
        trimestre: null,
        trimestres: [],
        libelles : libelles,
        gpecRealise : gpecRealise,
        marcheIdsItems: [],
      }
    },
    computed: {
      user() {
        if(this.mode === "BROUILLON" || this.mode === "CREATE"){
          return {
          email: SessionStore.state.email, 
          prenom: SessionStore.state.prenom, 
          nom: SessionStore.state.nom}
        }
          return{
          email: this.synthese.user?.email || '',
          prenom: this.synthese.user?.prenom || '',
          nom: this.synthese.user?.nom || ''
        }
    },
      mode() {
        return !this.$route.params.id || this.synthese.statut === "BROUILLON" ? 'CREATE' : (this.synthese.statut === 'VALIDE' && !hasPermission(["CORRESPONDANT_GPEC_LECTURE"])) ? 'UPDATE' : 'READ';
      },
      isAdminGpec() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_GPEC_ADMINISTRATEUR"]);
      },
      isAdmin() {
        return this.isAdminGpec && !this.sessionStoreState.marches.length;
      },
      marche() {
        return this.isAdmin ? this.marches.find(marche => marche.id === this.marcheAdmin) : this.sessionStoreState.marche;
      },
      marcheId() {
        return this.mode === 'CREATE' ? this.isAdmin ? this.marcheAdmin : this.sessionStoreState.marche.id : this.synthese.marche ? this.synthese.marche.id : null;
      },
      currentPostes() {
        let postes = this.synthese.postes;
        if (this.filterLibellePoste) {
          postes = postes.filter(poste => poste.codeRome.libelle.toLowerCase().includes(this.filterLibellePoste.toLowerCase()));
        }
        if (this.filterStatutPoste) {
          postes = postes.filter(poste => poste.isTouched || this.isValid(poste));
        }
        return postes;
      }
    },
    watch: {
      $route() {
        this.initSynthese();
      },
      marcheAdmin(newMarcheAdmin) {
        this.onMarcheSearch(newMarcheAdmin, true);
        this.callInit()
      },
    },
    mounted() {
      TypeFormationStore.getAll().then(
          response => this.typesFormation = response.map(value => {
            return {text: value.libelle, value: value};
          })
      );
      TrimestreStore.getAll().then(trimestres => {
        this.trimestres = trimestres.map(trimestre => {
          return {text: `${trimestre.libelle}`, value: trimestre.id};
        });
      });
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches;
          this.marchesAdmin = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
          this.marcheIdsItems = this.marchesAdmin;
        });
      }
      EventBus.$on("NavBar-marcheChange", () => {
        if (!this.isAdmin) {
          this.initSynthese();
        }
      });
      if (!this.$route.params.id) {
        TrimestreStore.getCurrentTrimestre(true).then((trimestre) => {
          this.trimestre = trimestre.id;
          this.callInit();
        });
      } else {
        this.initSynthese();
      }
    },
    beforeDestroy() {
      EventBus.$off("NavBar-marcheChange");
    },
    methods: {
      initSynthese() {
        this.marcheAdmin = null;
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        });
        if (this.$route.params.id) {
          GpecSyntheseRealiseStore.get(this.$route.params.id).then(value => {
            if (value) {
              this.synthese = value;
              this.marcheAdmin = value.marche.id;
              this.trimestre = value.trimestre.id;
            }
          });
        } else {
          this.callInit();
        }
      },
      callInit() {
        if (this.marcheId && this.trimestre && this.mode === 'CREATE' && !this.$route.params.id) {
          GpecSyntheseRealiseStore.getCurrentDraft(this.marcheId, this.trimestre).then(value => {
            if (value) {
              AlertStore.pushSuccess('Votre formulaire est actuellement enregistré en brouillon, n\'oubliez pas de compléter votre saisie avant de soumettre le formulaire pour le valider');
              this.synthese = value;
              this.trimestre = value.trimestre.id;
            } else {
              GpecSyntheseRealiseStore.init(this.marcheId, this.trimestre).then(synthese => {
                if (synthese) {
                  this.synthese = synthese;
                  this.trimestre = synthese.trimestre.id;
                  if (this.synthese.postes.some(poste => this.isFilledInput(poste.nbRecrutement))) {
                    AlertStore.pushSuccess('Votre formulaire est actuellement enregistré en brouillon et a été automatiquement prérempli par les données disponibles saisies de façon prévisionnelle, n’oubliez pas de modifier et/ou compléter le formulaire pour le valider');
                  }
                }
              });
            }
          });
        }
      },
      formatTrimestre(trimestreLibelle) {
        return formatTrimestre(trimestreLibelle);
      },
      getFieldState(fieldState, poste) {
        const posteTouched = poste ? poste.isTouched : true;
        return this.formSubmitted && posteTouched ? fieldState : null;
      },
      getCommentaireState() {
        const commentaireValid = this.mode === 'CREATE' ? true : this.synthese.jourSoumissionPassed ? this.synthese.commentaire != null : true;
        return this.formSubmitted ? commentaireValid : null;
      },
      getStatus(poste) {
        if (this.isValid(poste)) {
          return 'success';
        } else {
          if (this.isFilledInput(poste.nbRecrutement)) {
            poste.isTouched = true;
          }
          return !poste.isTouched ? 'secondary' : 'danger';
        }
      },
      isFilledInput(value) {
        return value != null && value !== "";
      },
      areEntreeSortieEntrepriseValid(poste) {
        if (this.isFilledInput(poste.nbRecrutement) && (this.isFilledInput(poste.integrationEntreprise) || this.isFilledInput(poste.sortieEntreprise))) {
          const integrationEntreprise = this.isFilledInput(poste.integrationEntreprise) ? Number(poste.integrationEntreprise) : 0;
          const sortieEntreprise = this.isFilledInput(poste.sortieEntreprise) ? Number(poste.sortieEntreprise) : 0;
          return Number(poste.nbRecrutement) >= integrationEntreprise + sortieEntreprise;
        } else {
          return true;
        }
      },
      areTypesContratValid(poste) {
        const typesContrat = poste.typesContrat;
        if (typesContrat == null || typesContrat.length === 0 || !this.isFilledInput(poste.nbRecrutement)) {
          return true;
        } else {
          const sommeTypesContrat = typesContrat.reduce((acc, currentVal) => {
            return this.isFilledInput(currentVal.nbEffectif) ? acc + Number(currentVal.nbEffectif) : acc;
          }, 0);
          return sommeTypesContrat === Number(poste.nbRecrutement);
        }
      },
      areDureesContratValid(poste) {
        const dureesContrat = poste.dureesContrat;
        if (dureesContrat == null || dureesContrat.length === 0 || !this.isFilledInput(poste.nbRecrutement)) {
          return true;
        } else {
          const sommeDureesContrat = dureesContrat.reduce((acc, currentVal) => {
            return this.isFilledInput(currentVal.nbEffectif) ? acc + Number(currentVal.nbEffectif) : acc;
          }, 0);
          return sommeDureesContrat === Number(poste.nbRecrutement);
        }
      },
      areTypesFormationValid(poste) {
        const formation = poste.formation;
        if (formation == null || !this.isFilledInput(poste.nbRecrutement)) {
          return true;
        } else {
          const sommeEffectifs = (this.isFilledInput(formation.nbInsertion) ? Number(formation.nbInsertion) : 0) + (this.isFilledInput(formation.nbInsertionHorsInsertion) ? Number(formation.nbInsertionHorsInsertion) : 0)
          return sommeEffectifs <= Number(poste.nbRecrutement);
        }
      },
      isValid(poste) {
        const fieldsOk = poste.codeRome.type != null && this.isFilledInput(poste.nbRecrutement) && this.areEntreeSortieEntrepriseValid(poste);
        const formation = poste.formation;
        const formationOk = (formation == null) || (formation != null && formation.type != null && this.isFilledInput(formation.duree) && this.isFilledInput(formation.nbInsertion)
            && this.isFilledInput(formation.nbInsertionHorsInsertion)
            && this.areTypesFormationValid(poste));
        const typesContrat = poste.typesContrat;
        const everyTypeContratOk = typesContrat != null && typesContrat.every(typeContrat => typeContrat.type != null && this.isFilledInput(typeContrat.nbEffectif));
        const typesContratOk = everyTypeContratOk && typesContrat.length > 0 && this.areTypesContratValid(poste);
        const dureesContrat = poste.dureesContrat;
        const everyDureeContratOk = dureesContrat != null && dureesContrat.every(dureeContrat => dureeContrat.duree != null && this.isFilledInput(dureeContrat.nbEffectif));
        const dureesContratOk = everyDureeContratOk && dureesContrat.length > 0 && this.areDureesContratValid(poste);
        return fieldsOk && formationOk && typesContratOk && dureesContratOk;
      },
      showModalAddPoste() {
        this.newCodeRome = new CodeRomeDto();
        this.$bvModal.show('modal-add-poste');
      },
      addPoste() {
        if (this.newCodeRome.id != null) {
          if (this.synthese.postes.find(poste => poste.codeRome.id === this.newCodeRome.id)) {
            AlertStore.pushError('le poste que vous souhaitez ajouter existe déjà dans le référentiel. En remontant en haut du formulaire vous pouvez filtrer la liste sur ce poste en entrant son intitulé dans la barre de recherche');
          } else {
            const poste = new PosteRealiseDto();
            if (!this.newCodeRome.type) {
              this.newCodeRome.customType = true;
            }
            poste.isTouched = true;
            poste.codeRome = this.newCodeRome;
            this.synthese.postes.push(poste);
            const correspondantGpecMsg = "Le poste a bien été ajouté au référentiel, en attente de validation de son intitulé et ajout définitif au référentiel, vous pouvez saisir les besoins qui y sont associés";
            const adminMsg = "Le poste a bien été ajouté au référentiel, vous pouvez saisir les besoins qui y sont associés";
            const successMessage = this.isAdminGpec ? adminMsg : correspondantGpecMsg;
            AlertStore.pushSuccess(successMessage);
          }
          this.filterLibellePoste = null;
          this.filterStatutPoste = null;
        }
      },
      deletePoste(posteIndex) {
        this.synthese.postes.splice(posteIndex, 1);
      },
      saveDraft() {
        this.synthese.postes = this.synthese.postes.filter(poste => this.isValid(poste));
        this.synthese.marche = this.marche;
        GpecSyntheseRealiseStore.saveDraft(this.synthese).then(
            value => {
              this.synthese = value;
            }
        );
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.filterStatutPoste = null;
        this.filterLibellePoste = null;
        const marcheAdminOk = this.isAdmin ? this.marcheAdmin != null : true;
        if (!this.synthese.postes.some(poste => this.isValid(poste))) {
          AlertStore.pushError('Le bilan doit comprendre au moins un recrutement exprimé');
          return;
        }
        if (marcheAdminOk && this.getCommentaireState() && this.synthese.postes.every(poste => this.isValid(poste) || !poste.isTouched)) {
          this.synthese.postes = this.synthese.postes.filter(poste => this.isValid(poste));
          if (this.mode === 'CREATE') {
            this.synthese.marche = this.marche;
            GpecSyntheseRealiseStore.create(this.synthese).then(() => this.initSynthese());
          } else {
            GpecSyntheseRealiseStore.update(this.synthese).then(() => this.$router.push("/gpec-bilan-trimestriel/consultation"));
          }
        } else {
          AlertStore.pushError(`Votre formulaire est incomplet. Veuillez finaliser votre saisie pour valider le formulaire.`);
        }
      },
      validerSynthese(synthese) {
        GpecSyntheseRealiseStore.validate(synthese).then(() => {
          this.$router.push("/gpec-bilan-trimestriel/validation");
        });
      },
      addLineBreak(event, object, code, lineBreack) {
        object[code] = lineBreack ? event.target.value + '\n' : event
      },
      saveDispense() {
        const dispense = new DispenseReportingDto();
        dispense.marche = this.marche;
        dispense.ongletReporting = "GPEC_REALISE";
        dispense.trimestreId = this.trimestre;
        ReportingStore.create(dispense, true);
      },
      onMarcheSearch(marche, isId){
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
      }
    }
  }
</script>

<style lang="scss" scoped>
    .card-body {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
    .user-info {
        background-color: #f0f0f0;
        padding: 10px;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        box-sizing: border-box;
        word-break: break-word;
    }
    .no-data {
        text-align: center;
        font-style: italic;
        color: #888;
    }
</style>
